module.exports = __webpack_public_path__ + "static/media/surveys-bg-desktop.5b07403d.jpg";